export default __webpack_public_path__ + "static/media/Helm of the Black Pharaoh.0f63a7a7.jpg";